module.exports = __webpack_public_path__ + "img/nav-wishlist.64797c0.jpg";